<template>
    <div class="system-notification-wrap common-pagination">
        <header class="nav-inner">
            <p>{{$t('notification.system.nav')}}</p>
        </header>
        <main v-if="user.username" class="has-login-warp">
            <header class="mark-all">
                <label @click="markAll">{{$t('notification.system.mark_all')}}</label>
            </header>
            <div class="table-div">
                <ul>
                    <li v-for="item in systemData" class="clear"
                        @click="getJump(item)">
                        <label class="icon-read" :class="{'icon-no-read':item.readStatus === 0}"></label>
                        {{item.title}}
                        <span class="right">{{dateFormatter(new Date(item.createTime), 'yyyy-MM-dd hh:mm:ss')}}</span>
                    </li>
                </ul>
            </div>
        </main>
        <div v-if="user.username" class="pg-wrap">
            <el-pagination
                    background
                    @current-change="getSystemData"
                    :current-page.sync="filterData.page"
                    :page-size="filterData.rows"
                    layout="prev, pager, next, jumper"
                    :total="total">
            </el-pagination>
        </div>
        <main v-else class="no-login-wrap">
            <div class="con-div">
                <router-link to="/login">
                    <img src="../../assets/img/icon_login_user.png">
                </router-link>
                <p><router-link to="/login">{{$t('notification.system.login_check')}}</router-link></p>
            </div>
        </main>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import bus from '../../assets/js/bus';

    export default {
        name: "SystemNotification",
        data() {
            return {
                filterData: {
                    page: 1,
                    rows: 10
                },
                total: 0,
                systemData: []
            }
        },
        created() {
            this.getSystemData();
        },
        methods: {
            markAll() {
                this.$axios.post('/notify/setRead',{}).then(res => {
                    if (res.data.code === this.errorCode.ok) {
                        this.$message({
                            type: 'success',
                            message: this.$t('notification.system.mark_success')
                        });
                        this.getSystemData();
                        bus.$emit('updateSystemData');
                    }
                });
            },
            getSystemData() {
                this.$axios.post('/notify/getMessageNotify', this.filterData).then(res => {
                    this.systemData = res.data.data.rows;
                })
            },
            getJump(item) {
                let url = '';
                switch (item.contentType) {
                    case 'withdraw':
                        url = '/userAssets/tradeRecord?tagShow=withdraw';
                        break;
                    case 'deposit':
                        url = '/userAssets/tradeRecord?tagShow=recharge';
                        break;
                    case 'rebate':
                        url = '/userAssets/tradeRecord?tagShow=other';
                        break;
                    case 'burstBlock':
                        url = '/userAssets/blockDetail?id='+item.jumpInfo.id;
                        break;
                    case 'otc':
                        url = '/otc/otcOrderConfirm?otcType='+item.jumpInfo.side+'&identity='+item.jumpInfo.queryType+'&otcOrderId='+item.jumpInfo.orderId;
                        break;
                    default:
                        url = '#';
                        break;
                }
                if (item.readStatus === 0) {
                    this.$axios.post('/notify/setRead',{ids: [item.id]}).then(res => {
                        if (res.data.code === this.errorCode.ok) {
                            this.getSystemData();
                            bus.$emit('updateSystemData');
                        }
                    });
                }
                this.$router.push({path: url});
            }
        },
        computed: {
            ...mapState([
                'user',
                'errorCode'
            ])
        }
    }
</script>

<style lang="less" scoped>
 .system-notification-wrap {
     min-height: calc(~'100% - 50px');
     background: #F3F3F9;
    .nav-inner {
        background: white;
        height: 50px;
        line-height: 50px;
        p {
            width: 1200px;
            margin: auto;
            font-size: 16px;
        }
    }
     .has-login-warp {
         width: 1200px;
         margin: 88px auto 0;
         background: white;
         .mark-all {
             height: 60px;
             line-height: 60px;
             text-align: center;
             border-bottom: 2px solid #EEEEEE;
             color: #42CB83;
             label {
                 cursor: pointer;
             }
         }
         .table-div {
             ul li {
                 cursor: pointer;
                 padding: 20px;
                .icon-read {
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    background: #D8D8D8;
                    margin-right: 10px;
                }
                 .icon-no-read {
                     background: #F04C66;
                 }
             }
         }
     }
     .pg-wrap {
         margin-top: 20px;
         text-align: center;
     }
     .no-login-wrap {
         width: 1200px;
         height: 626px;
         margin: 88px auto 0;
         display: table;
         background: white;
         .con-div {
             text-align: center;
             display: table-cell;
             vertical-align: middle;
             p {
                 margin-top: 26px;
                 color: #42CB83;
             }
         }
     }
 }
</style>